import { useMemo } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { DATE } from "helpers/shapes"
import { isLongShortOnlySegment, POSITION_SET } from "../position-sets"
import useSegmentHeaderLabel from "../hooks/use-segment-header-label"
import CompareItemSubHeader from "./item-sub-header"

export default function CompareItemModifiers({ positionSet, currency, endDate }) {
  const instrument = useMemo(() => ({
    type: positionSet.queryStringPositionSet?.type,
    id: positionSet.queryStringPositionSet?.id,
  }), [positionSet.queryStringPositionSet])

  const displaySegmentFilters = positionSet.effectiveSegmentFilters
  const resolvedSegmentHeader = useSegmentHeaderLabel(instrument, endDate, displaySegmentFilters, positionSet.normalization, currency)

  const additionalHeaders = useMemo(() => {
    if (!resolvedSegmentHeader || !positionSet.segmentHeader || resolvedSegmentHeader === positionSet.segmentHeader) {
      return positionSet.additionalHeaders
    }
    return map(positionSet.additionalHeaders, header => (header === positionSet.segmentHeader ? resolvedSegmentHeader : header))
  }, [positionSet.additionalHeaders, positionSet.segmentHeader, resolvedSegmentHeader])

  const displayedSegmentHeader = resolvedSegmentHeader || positionSet.segmentHeader || null
  const collapsibleSegmentHeaderText = displayedSegmentHeader && !isLongShortOnlySegment(displaySegmentFilters) ? displayedSegmentHeader : null

  return <CompareItemSubHeader additionalHeaders={additionalHeaders} segmentHeaderText={collapsibleSegmentHeaderText} />
}

CompareItemModifiers.propTypes = {
  positionSet: PropTypes.shape(POSITION_SET).isRequired,
  currency: PropTypes.string,
  endDate: DATE.isRequired,
}
